import { createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("ユーザー設定")
const _hoisted_2 = { class: "flex items-end w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "leading-7 text-sm text-gray-600"
}, " 名前 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 更新 ")
const _hoisted_6 = { class: "flex items-end w-3/4 mx-auto mb-4" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "leading-7 text-sm text-gray-600"
}, [
  /*#__PURE__*/_createTextVNode(" メールアドレス "),
  /*#__PURE__*/_createVNode("span", { class: "ml-2 font-medium text-sm text-gray-500" }, " ※変更すると、ログイン時に使用しているメールアドレスも変更となります。 ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 更新 ")
const _hoisted_10 = { class: "flex items-end w-3/4 mx-auto mb-6" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "leading-7 text-sm text-gray-600"
}, " Googleアカウント ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 更新 ")
const _hoisted_14 = { class: "flex items-end w-3/4 mx-auto mb-6" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "leading-7 text-sm text-gray-600"
}, " Microsoftアカウント ", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 更新 ")
const _hoisted_18 = {
  key: 0,
  class: "w-3/4 px-3 py-4 mx-auto mb-6 flex flex-col items-center bg-primary-100 rounded-md"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "mb-2 font-medium text-sm text-gray-500" }, " ※ メールアドレスの認証が完了していません ", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 認証用メールを送信 ")
const _hoisted_21 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "w-full text-center text-sm text-green-400" }, "※ メール認証済", -1)
const _hoisted_23 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6 flex flex-col"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "パスワード", -1)
const _hoisted_25 = { class: "px-4 py-4 bg-primary-100 rounded-md flex flex-wrap items-center gap-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  class: "flex-1 text-sm text-gray-600",
  style: {"min-width":"12rem"}
}, [
  /*#__PURE__*/_createVNode("p", null, "メールアドレスでログインするときに使います。")
], -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 変更する ")
const _hoisted_28 = {
  key: 0,
  class: "mt-2 text-xs text-gray-500"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" パスワードを忘れたときは、 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("できます。 ")
const _hoisted_31 = {
  key: 3,
  class: "w-3/4 px-3 py-6 mx-auto mb-6 flex flex-col items-center bg-primary-100 rounded-md"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "mb-4 text-sm text-center text-gray-500" }, " パスワードを変更したい場合は、パスワード再設定メールを送信してください。 ", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" パスワード再設定メールを送信 ")
const _hoisted_34 = {
  key: 4,
  class: "w-3/4 mx-auto mb-6 flex flex-col"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "通知メール受信設定", -1)
const _hoisted_36 = { class: "px-3 py-4 bg-primary-100 rounded-md" }
const _hoisted_37 = { class: "w-full mb-2 flex items-center" }
const _hoisted_38 = { class: "w-full flex items-center" }
const _hoisted_39 = {
  key: 0,
  class: "mt-2 w-full text-center text-gray-500 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
            type: "text",
            name: "name",
            placeholder: "例）皆学太郎",
            class: "w-full bg-primary-100 rounded border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
          }, null, 512), [
            [_vModelText, _ctx.username]
          ])
        ]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validName,
          class: "ml-4 mb-1",
          onClick: _ctx.updateName
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
            type: "email",
            name: "email",
            placeholder: "例）info@mingaku.net",
            class: ["w-full bg-primary-100 rounded border focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300", _ctx.dynamicEmailCss]
          }, null, 2), [
            [_vModelText, _ctx.email]
          ])
        ]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validEmail,
          class: "ml-4 mb-1",
          onClick: _ctx.updateEmail
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.googleAccountEmail = $event)),
            type: "text",
            name: "google-account-email",
            placeholder: "Gmailを入力してください（任意）",
            class: "w-full bg-primary-100 rounded border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
          }, null, 512), [
            [_vModelText, _ctx.googleAccountEmail]
          ])
        ]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validGoogleAccountEmail,
          class: "ml-4 mb-1",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateExternalServiceEmail('google')))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.microsoftAccountEmail = $event)),
            type: "text",
            name: "microsoft-account-email",
            placeholder: "Microsoftメールを入力してください（任意）",
            class: "w-full bg-primary-100 rounded border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
          }, null, 512), [
            [_vModelText, _ctx.microsoftAccountEmail]
          ])
        ]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validMicrosoftAccountEmail,
          class: "ml-4 mb-1",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateExternalServiceEmail('microsoft')))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (!_ctx.isVerifiedEmail)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_m_button, {
              color: "primary-500",
              "hover-color": "primary-600",
              onClick: _ctx.sendVerifyEmail
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_21, [
            _hoisted_22
          ])),
      (_ctx.canChangePassword)
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.openPasswordChange
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            (_ctx.isVerifiedEmail)
              ? (_openBlock(), _createBlock("p", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("button", {
                    type: "button",
                    class: "underline hover:text-gray-700",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendPasswordResetEmail && _ctx.sendPasswordResetEmail(...args)))
                  }, " 再設定メールを送信"),
                  _hoisted_30
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isVerifiedEmail)
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.sendPasswordResetEmail
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
      (_ctx.isTutor)
        ? (_openBlock(), _createBlock("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _withDirectives(_createVNode("input", {
                  id: "allowEmailNotify",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.allowEmailNotify = $event)),
                  type: "checkbox",
                  name: "allowEmailNotify",
                  class: "flex-none",
                  disabled: !_ctx.isVerifiedEmail
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.allowEmailNotify]
                ]),
                _createVNode("label", {
                  for: "allowEmailNotify",
                  class: ["flex-1 pl-2", { 'text-gray-400': !_ctx.isVerifiedEmail }]
                }, " 生徒が学習室に入退室したときに通知メールを受け取る ", 2)
              ]),
              _createVNode("div", _hoisted_38, [
                _withDirectives(_createVNode("input", {
                  id: "allowBadgeEmailNotify",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.allowBadgeEmailNotify = $event)),
                  type: "checkbox",
                  name: "allowBadgeEmailNotify",
                  class: "flex-none",
                  disabled: !_ctx.isVerifiedEmail
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.allowBadgeEmailNotify]
                ]),
                _createVNode("label", {
                  for: "allowBadgeEmailNotify",
                  class: ["flex-1 pl-2", { 'text-gray-400': !_ctx.isVerifiedEmail }]
                }, " 生徒がバッジを獲得したときに通知メールを受け取る ", 2)
              ])
            ]),
            (!_ctx.isVerifiedEmail)
              ? (_openBlock(), _createBlock("div", _hoisted_39, " ※ 通知メールを受け取るにはメールアドレスの認証が必要です。先に認証を完了させてください。 "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClose"]))
}